import { render, staticRenderFns } from "./DossierNew.vue?vue&type=template&id=79ee1e49&"
import script from "./DossierNew.vue?vue&type=script&lang=ts&"
export * from "./DossierNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ee1e49')) {
      api.createRecord('79ee1e49', component.options)
    } else {
      api.reload('79ee1e49', component.options)
    }
    module.hot.accept("./DossierNew.vue?vue&type=template&id=79ee1e49&", function () {
      api.rerender('79ee1e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierNew.vue"
export default component.exports